import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';

import {
  solutionOpen
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].type,
    open: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].open,
    fullName: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].fullName,
    solutionAlias: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].solutionAlias,
    volume: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].volume,
    solutionColor: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].solutionColor,
    size: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].size,
    circleColor: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].circleColor,
    circleOutline: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].circleOutline,
    renamable: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].renamable,
    label: state.notebook.protocolSection.scene.apparatus.solutions[ownProps.id - 1].label,
    labelReactionTubes: state.notebook.protocolSection.scene.labelReactionTubes,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    solutionOpen: (data) => {
      dispatch(solutionOpen(data))
    },
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
